import React, { useRef, useState, useEffect, useContext } from "react";
import { ContextBoard } from "../../context/ContextBoard";
import { useLocation, useNavigate } from "react-router-dom";
import Footer from "../shared/Footer";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import config from "../../config";
import $ from "jquery";
import Swal from "sweetalert2";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import { motion, AnimatePresence } from "framer-motion";
import { MdOutlineKeyboardDoubleArrowRight } from "react-icons/md";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { MdOutlineKeyboardDoubleArrowLeft } from "react-icons/md";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";

function Paymentpending11() {
  const tableRef = useRef(null);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [challanNo, setChallanNo] = useState([]);

  const [modalData, setModalData] = useState({});
  const [chFile, setChFile] = useState();
  const [isImage, setIsImage] = useState(false);
  const [isPDF, setIsPDF] = useState(false);

  const remarksRef = useRef(null);
  const [showMainModal, setShowMainModal] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);

  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(100);

  const { selectedDistrict } = useContext(ContextBoard);
  const token = sessionStorage.getItem("intermediateaccountstoken");

  const navigate = useNavigate();
  useEffect(() => {
    if (!selectedDistrict) {
      navigate("/intermediate-accounts-dashboard-class-xi");
      return;
    }
  }, [navigate]);
  const fetchData = async () => {
    try {
      const response = await fetch(
        `${config.API_BASE_URL}/FOPaymentPendingVerification_CL11`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ districtcode: selectedDistrict }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const data = await response.json();
      // console.log("Fetched data:", data);
      setTableData(data.data.pendingVerification_details);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching table data:", error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const filteredData = tableData.filter((row) => {
    const query = searchQuery.toLowerCase();
    return (
      row.district?.toLowerCase().includes(query) ||
      row.schooL_CODE?.toLowerCase().includes(query) ||
      row.schooL_NAME?.toLowerCase().includes(query) ||
      row.challaN_NO?.toLowerCase().includes(query) ||
      row.nO_OF_STUDENT?.toLowerCase().includes(query) ||
      row.paymenT_DATE_TIME?.toLowerCase().includes(query) ||
      row.paymenT_MODE?.toLowerCase().includes(query)
    );
  });

  const totalPages = Math.ceil(filteredData.length / perPage);
  const indexOfLastItem = currentPage * perPage;
  const indexOfFirstItem = indexOfLastItem - perPage;

  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const handlePerPageChange = (e) => {
    setPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const generateExcel = async () => {
    if (!tableData.length) {
      Swal.fire("No Data", "No student data available for export.", "warning");
      return;
    }

    const token = sessionStorage.getItem("intermediateaccountstoken");
    if (!token) {
      Swal.fire(
        "Authentication Error",
        "Token is missing. Please log in.",
        "error"
      );
      return;
    }

    try {
      setLoading(true);

      const now = new Date();
      const formattedDateTime = `${now
        .getDate()
        .toString()
        .padStart(2, "0")}-${(now.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${now.getFullYear()} ${now
        .getHours()
        .toString()
        .padStart(2, "0")}:${now.getMinutes().toString().padStart(2, "0")}:${now
        .getSeconds()
        .toString()
        .padStart(2, "0")}`;

      const ws = XLSX.utils.aoa_to_sheet([
        ["Pending for Verification"],
        // ["Challan No:", newchallan],
        // ["Challan Generation Date & Time:", newdatetime],
        ["Pending for Verification Print Date & Time:", formattedDateTime],
        [],
        [],
        [
          "Sl. No",
          "District",
          "School Code",
          "School Name",
          "Challan No.",
          "No. of Students",
          "Payment Date & Time",
          "Payment Mode",
        ],
      ]);

      const rows = tableData.map((student, index) => [
        index + 1,
        student.district || "",
        student.schooL_CODE || "",
        student.schooL_NAME || "",
        student.challaN_NO || "",
        student.nO_OF_STUDENT || "",
        student.paymenT_DATE_TIME || "",
        student.paymenT_MODE || "",
      ]);

      XLSX.utils.sheet_add_aoa(ws, rows, { origin: -1 });

      ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 7 } }];

      ws["!cols"] = [
        { wch: 8 }, // Sl. No
        { wch: 25 }, // Name
        { wch: 15 }, // Gender
        { wch: 15 }, // Caste
        { wch: 15 }, // Category
        { wch: 15 }, // Exam Fees
      ];

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Checklist");

      const fileName = `Pending_for_Verification.xlsx`;
      XLSX.writeFile(wb, fileName);

      setLoading(false);

      Swal.fire({
        title: "Success",
        text: "Excel file has been generated successfully!",
        icon: "success",
        timer: 1500,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error("Error generating Excel:", error);
      setLoading(false);
      Swal.fire(
        "Error",
        "An error occurred while generating the checklist.",
        "error"
      );
    }
  };

  const openModal = async (challanNo) => {
    setChallanNo(challanNo);
    setLoading(true);
    try {
      const response = await fetch(
        `${config.API_BASE_URL}/FOShowPaymentDetailsChallan_CL11`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ challaN_NO: challanNo }),
        }
      );
      const data = await response.json();
      setModalData(data.data.paymentChallan_details || {});
      setChFile(data.data.paymentChallan_details.cH_FILE_URL || {});
      setIsImage(
        /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(
          data.data.paymentChallan_details.cH_FILE
        )
      );
      setIsPDF(/\.pdf$/i.test(data.data.paymentChallan_details.cH_FILE));
      setShowMainModal(true);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const closeModal = () => {
    setShowMainModal(false);
    setModalData({});
  };

  const openRejectModal = () => {
    setShowRejectModal(true);
  };

  const closeRejectModal = () => {
    setShowRejectModal(false);
  };

  const handleSubmit = async (status) => {
    let remarks = "";

    if (status === "REJECTED") {
      remarks = remarksRef.current ? remarksRef.current.value.trim() : "";

      if (!remarks) {
        toast.warning("Please provide remarks before rejecting.");
        return;
      }
    }

    setLoading(true);

    const token2 = sessionStorage.getItem("intermediateaccountstoken");
    try {
      setLoading(true);

      const response = await fetch(
        `${config.API_BASE_URL}/FOPendingStatusUpdateApproRejct_CL11`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token2}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            remarks: remarks,
            challaN_NO: challanNo,
            status: status,
          }),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      setLoading(false);

      Swal.fire({
        icon: "success",
        // title: "Success",
        title: `SUCCESSFULLY ${
          status === "APPROVED" ? "APPROVED" : "REJECTED"
        }`,
        customClass: "custom-swal",
      }).then(async () => {
        setTableData([]);
        await fetchData();
      });

      // Close modals
      if (status === "APPROVED") {
        closeModal();
      } else {
        closeModal();
        closeRejectModal();
      }
    } catch (error) {
      setLoading(false); // Stop loader on error
      console.error("Error submitting:", error);
      toast.error("Something went wrong. Please try again.");
    }
  };

  // const handleDownload = async (chFile, challanNo) => {
  //   if (!chFile) return;
  //   try {
  //     // Replace http with https
  //     const chFile1 = chFile.replace("http://", "https://");

  //     // const response = await fetch(chFile1);
  //     // const blob = await response.blob();

  //     // // Detect file extension from MIME type
  //     // const mimeType = blob.type;
  //     // let fileExtension = "file";
  //     // if (mimeType.includes("image")) fileExtension = "jpg";
  //     // else if (mimeType === "application/pdf") fileExtension = "pdf";

  //     // const fileName = `${challanNo}.${fileExtension}`;
  //     // saveAs(blob, fileName);
  //     const fileName = chFile1
  //       .substring(chFile1.lastIndexOf("/") + 1)
  //       .split("?")[0];

  //     const finalUrl = chFile1;
  //     console.log(finalUrl);
  //     const link = document.createElement("a");
  //     link.href = finalUrl;
  //     link.download = fileName;
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //   } catch (error) {
  //     console.error("Download failed", error);
  //   }
  // };
  const handleDownload = async (presignedUrl, challanNo) => {
    if (!presignedUrl) {
      alert("No file URL provided!");
      return;
    }

    setLoading(true);
    try {
      // Always request a fresh presigned URL from backend before download (recommended)
      const safeUrl = presignedUrl.replace(/^http:\/\//i, "https://");

      // Disable caching to avoid stale URL or CORS cache
      const response = await fetch(safeUrl, {
        mode: "cors",
        cache: "no-store",
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const blob = await response.blob();

      const mimeType = blob.type || "application/octet-stream";
      let ext = "file";
      if (mimeType.includes("pdf")) ext = "pdf";
      else if (mimeType.includes("image")) ext = "jpg";

      const fileName = `${challanNo || "download"}.${ext}`;

      // ✅ Don’t revoke the blob URL immediately — delay by 1 second
      const blobUrl = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Delay revocation
      setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);

      console.log("✅ File downloaded successfully!");
    } catch (err) {
      console.error("❌ Download failed:", err);
      alert("Failed to download file. Check console for details.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div class="container-scroller">
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
      <Navbar />
      {loading && (
        <div className="custom-loader-container">
          <div className="custom-loader"></div>
        </div>
      )}
      <div class="container-fluid page-body-wrapper">
        <Sidebar />
        <div class="main-panel">
          <div class="content-wrapper">
            <div class="row">
              <div class="col-md-12 mb-1">
                <section class="content-header">
                  <h1>
                    <i class="fa fa-user"></i>&nbsp; Pending for Verification
                  </h1>
                  <ol class="breadcrumb">
                    <li>
                      <a
                        href="accounts-dashboard"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate("/intermediate-accounts-dashboard-class-xi");
                        }}
                      >
                        <svg
                          stroke="currentColor"
                          fill="currentColor"
                          stroke-width="0"
                          viewBox="0 0 512 512"
                          height="1em"
                          width="1em"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{ marginTop: "-4px" }}
                        >
                          <path d="M256 64C132.3 64 32 164.2 32 287.9c0 57 21.3 109 56.3 148.5 1.1 1.2 2.1 2.4 3.2 3.5C96.3 445 103 448 110 448c7.1 0 13.8-3 18.6-8.2 31.6-34.4 77-55.9 127.4-55.9s95.8 21.6 127.4 55.9c4.8 5.2 11.5 8.2 18.6 8.2 7 0 13.7-2.9 18.5-8.1 1.1-1.2 2.1-2.3 3.2-3.5 35-39.5 56.3-91.5 56.3-148.5C480 164.2 379.7 64 256 64zm-14 45.9c0-7.7 6.3-14 14-14s14 6.3 14 14v36c0 7.7-6.3 14-14 14s-14-6.3-14-14v-36zm-128 192H78c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14zm51.5-104.5c-5.4 5.4-14.4 5.4-19.8 0L120.2 172c-5.4-5.4-5.4-14.4 0-19.8s14.4-5.4 19.8 0l25.5 25.5c5.4 5.4 5.4 14.3 0 19.7zm160.6 34.5l-47.5 75.5c-1.9 2.6-4.3 5.1-7 7-13.5 9.7-32.3 6.5-42-7s-6.5-32.3 7-42l75.5-47.5c3.4-2.4 8.1-2.5 11.7 0 4.5 3.2 5.5 9.5 2.3 14zm40.2-34.5c-5.4 5.4-14.4 5.4-19.8 0s-5.4-14.4 0-19.8l25.5-25.5c5.4-5.4 14.4-5.4 19.8 0s5.4 14.4 0 19.8l-25.5 25.5zM434 301.9h-36c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14z"></path>
                        </svg>{" "}
                        Home&nbsp;
                      </a>
                    </li>
                    <li class="active"> Pending for Verification</li>
                  </ol>
                  <h3></h3>
                </section>
              </div>
            </div>

            <div className="row" style={{ padding: "0px" }}>
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row mb-2">
                      {/* <div className="col-md-12 text-right">
                        {tableData.length > 0 ? (
                          <button
                            onClick={generateExcel}
                            className="btn btn-success btn-sm"
                          >
                            {" "}
                            <i class="fa fa-file-excel"></i> Export to Excel
                          </button>
                        ) : (
                          ""
                        )}
                      </div> */}
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <div className="d-flex align-items-center">
                            <label htmlFor="rowsPerPage" className="me-2 mb-0">
                              Rows:
                            </label>
                            <div style={{ width: "250px" }}>
                              <select
                                id="rowsPerPage"
                                className="form-select form-select-sm"
                                value={perPage}
                                onChange={handlePerPageChange}
                                style={{
                                  width: "80px", // or adjust as needed (80–120px)
                                  paddingRight: "2rem", // ensures space for the dropdown arrow
                                }}
                              >
                                {[10, 20, 50, 100, 500].map((num) => (
                                  <option key={num} value={num}>
                                    {num}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                          <div style={{ width: "200px" }}>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              placeholder="Search..."
                              value={searchQuery}
                              onChange={(e) => setSearchQuery(e.target.value)}
                            />
                          </div>
                        </div>

                        <div className="table-responsive">
                          <table className="table table-hover table-bordered mb-0 display">
                            <thead>
                              <tr
                                className="table-info"
                                style={{ textWrap: "nowrap" }}
                              >
                                <th>Sl. No</th>
                                <th>District</th>
                                <th>School Code</th>
                                <th>School Name</th>
                                <th>Challan Number</th>
                                <th>No. of Students</th>
                                <th>Payment Date & Time</th>
                                <th>Payment Mode</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {currentItems.length > 0 ? (
                                currentItems.map((item, index) => (
                                  <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{item.district}</td>
                                    <td>{item.schooL_CODE}</td>
                                    <td>{item.schooL_NAME}</td>
                                    <td>{item.challaN_NO}</td>
                                    <td style={{ textAlign: "right" }}>
                                      {item.nO_OF_STUDENT}
                                    </td>
                                    <td>
                                      <span
                                        class="btn btn-xs btn-warning"
                                        style={{ pointerEvents: "none" }}
                                      >
                                        {" "}
                                        {item.paymenT_DATE_TIME}
                                      </span>
                                    </td>
                                    <td>{item.paymenT_MODE}</td>
                                    <td>
                                      <button
                                        className="btn btn-info btn-sm"
                                        onClick={() =>
                                          openModal(item.challaN_NO)
                                        }
                                      >
                                        Initiate Verification
                                      </button>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    colSpan="9"
                                    className="text-center text-muted"
                                  >
                                    No data found.
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>

                        <div className="d-flex justify-content-between align-items-center mt-3">
                          <div>
                            Showing {(currentPage - 1) * perPage + 1} to{" "}
                            {Math.min(indexOfLastItem, filteredData.length)} of{" "}
                            {filteredData.length} entries
                          </div>
                          <div className="d-flex align-items-center gap-2">
                            <MdOutlineKeyboardDoubleArrowLeft
                              onClick={() => {
                                if (currentPage > 1) setCurrentPage(1);
                              }}
                              style={{
                                cursor:
                                  currentPage > 1 ? "pointer" : "not-allowed",
                                opacity: currentPage > 1 ? 1 : 0.5,
                              }}
                            />

                            <MdOutlineKeyboardArrowLeft
                              onClick={() => {
                                if (currentPage > 1)
                                  setCurrentPage((prev) => prev - 1);
                              }}
                              style={{
                                cursor:
                                  currentPage > 1 ? "pointer" : "not-allowed",
                                opacity: currentPage > 1 ? 1 : 0.5,
                              }}
                            />

                            <span>
                              Page {currentPage} of {totalPages}
                            </span>

                            <MdOutlineKeyboardArrowRight
                              onClick={() => {
                                if (currentPage < totalPages)
                                  setCurrentPage((prev) => prev + 1);
                              }}
                              style={{
                                cursor:
                                  currentPage < totalPages
                                    ? "pointer"
                                    : "not-allowed",
                                opacity: currentPage < totalPages ? 1 : 0.5,
                              }}
                            />

                            <MdOutlineKeyboardDoubleArrowRight
                              onClick={() => {
                                if (currentPage < totalPages)
                                  setCurrentPage(totalPages);
                              }}
                              style={{
                                cursor:
                                  currentPage < totalPages
                                    ? "pointer"
                                    : "not-allowed",
                                opacity: currentPage < totalPages ? 1 : 0.5,
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>

      <AnimatePresence>
        {showMainModal && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              backdropFilter: "blur(8px)",
              WebkitBackdropFilter: "blur(8px)",
              zIndex: 1100,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <motion.div
              initial={{ scale: 0.85, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.85, opacity: 0 }}
              transition={{ duration: 0.3 }}
              style={{
                width: "95%",
                maxWidth: "850px",
                background: "#fff",
                borderRadius: "12px",
                overflow: "hidden",
                boxShadow: "0 8px 30px rgba(0,0,0,0.2)",
              }}
            >
              <div
                className="modal-header bg-primary text-white"
                style={{ padding: "10px" }}
              >
                <h5 className="modal-title">
                  Uploaded Payment Details ( Challan No : {challanNo} )
                </h5>
                <button
                  type="button"
                  className="btn close"
                  style={{ filter: "invert(1)" }}
                  onClick={closeModal}
                >
                  <i className="fa fa-times"></i>
                </button>
              </div>

              <div className="modal-body" style={{ padding: "15px" }}>
                <div className="row">
                  <div className="col-md-7">
                    <table className="table">
                      <tbody>
                        <tr>
                          <td>Transaction Date :</td>
                          <td>
                            <input
                              className="form-control form-control-sm"
                              type="text"
                              name="paymentDate"
                              disabled
                              value={modalData.paymenT_DATE || ""}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>Transaction Number :</td>
                          <td>
                            <input
                              type="text"
                              name="document"
                              className="form-control form-control-sm"
                              disabled
                              value={modalData.transactioN_NUMBER || ""}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>Bank Name :</td>
                          <td>
                            <input
                              type="text"
                              name="bankName"
                              className="form-control form-control-sm"
                              value={modalData.banK_NAME || ""}
                              disabled
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>Amount :</td>
                          <td>
                            <input
                              type="text"
                              name="amount"
                              className="form-control form-control-sm text-right"
                              disabled
                              value={modalData.exaM_FEES || ""}
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div className="col-md-5" style={{ textAlign: "center" }}>
                    <div
                      style={{
                        height: "250px",
                        width: "100%",
                        marginBottom: "10px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                        fontSize: "18px",
                      }}
                    >
                      {isImage ? (
                        <img
                          src={chFile}
                          alt="Uploaded Preview"
                          style={{
                            maxHeight: "100%",
                            maxWidth: "100%",
                            border: "1px solid #ccc",
                            borderRadius: "5px",
                          }}
                        />
                      ) : isPDF ? (
                        <a
                          href={chFile}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            textDecoration: "none",
                            color: "black",
                            cursor: "pointer",
                            fontWeight: "bold",
                            padding: "10px 15px",
                            border: "1px solid #ccc",
                            borderRadius: "5px",
                            backgroundColor: "#f8f9fa",
                            transition: "background 0.3s",
                          }}
                          onMouseEnter={(e) =>
                            (e.target.style.backgroundColor = "#e2e6ea")
                          }
                          onMouseLeave={(e) =>
                            (e.target.style.backgroundColor = "#f8f9fa")
                          }
                        >
                          📄 View Details
                        </a>
                      ) : (
                        <div style={{ textAlign: "center" }}>
                          <img
                            src="/assets/no-image.png"
                            alt="No preview available"
                            style={{
                              width: "150px",
                              height: "auto",
                              border: "1px solid #ccc",
                              borderRadius: "5px",
                            }}
                          />
                        </div>
                      )}
                    </div>

                    <button
                      className="btn btn-primary btn-sm"
                      onClick={() => handleDownload(chFile, challanNo)}
                    >
                      <i className="fa fa-download"></i> Download
                    </button>
                  </div>
                </div>
              </div>

              <div
                className="modal-footer"
                style={{ padding: "10px", display: "flex", gap: "5px" }}
              >
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={openRejectModal}
                >
                  <i className="fa fa-times"></i>&nbsp;Reject
                </button>
                <button
                  type="button"
                  className="btn btn-primary btn-sm"
                  onClick={() => handleSubmit("APPROVED")}
                >
                  <i className="fa fa-save"></i>&nbsp;Approve
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      <AnimatePresence>
        {showRejectModal && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              backdropFilter: "blur(8px)",
              WebkitBackdropFilter: "blur(8px)",
              zIndex: 1100,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <motion.div
              initial={{ scale: 0.85, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.85, opacity: 0 }}
              transition={{ duration: 0.3 }}
              style={{
                width: "95%",
                maxWidth: "400px",
                background: "#fff",
                borderRadius: "12px",
                overflow: "hidden",
                boxShadow: "0 8px 30px rgba(0,0,0,0.2)",
              }}
            >
              <div
                className="modal-header bg-primary text-white"
                style={{ padding: "10px" }}
              >
                <h5 className="modal-title">Reject Payment Details</h5>
                <button
                  type="button"
                  className="btn close"
                  style={{ filter: "invert(1)" }}
                  onClick={closeRejectModal}
                >
                  <i className="fa fa-times"></i>
                </button>
              </div>

              <div className="modal-body" style={{ padding: "15px" }}>
                <h5>Remarks:</h5>
                <textarea
                  className="form-control"
                  rows={4}
                  ref={remarksRef}
                ></textarea>
              </div>

              <div
                className="modal-footer"
                style={{ padding: "10px", display: "flex", gap: "5px" }}
              >
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={closeRejectModal}
                >
                  <i className="fa fa-times"></i>&nbsp;Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary btn-sm"
                  onClick={() => handleSubmit("REJECTED")}
                >
                  <i className="fa fa-save"></i>&nbsp;Save
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default Paymentpending11;
